export const roles = {
    superAdmin: 'admin',
    vendorUser: 'Vendor User',
    oesCompanyAdmin: 'OES Company Admin',
    oesCompanyUser: 'OES Company User',
    oesMasterCustomerUser: 'OES Master Customer User'
};



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/roles.ts